import { Form, Formik, FormikProps } from "formik";
import style from "./UserInfoForm.module.scss";
import * as Yup from 'yup';
import { Input } from "@ui";
import { forwardRef } from "react";
import { useGetUserQuery } from "@RTKQuery/user/auth/auth";
import { IUser } from "@interfaces/user/user";

const UserInfoForm = forwardRef<FormikProps<Pick<IUser, "first_name" | "last_name" | "phone_number" | "email" | "instagram" | "telegram">>, {}>((_, ref) => {
    const { data } = useGetUserQuery();

    return (
        <div className={style.container}>
            <p className={style.formLabel}>Особисті дані</p>
            <Formik
                innerRef={ref}
                initialValues={{
                    first_name: data?.first_name || "",
                    last_name: data?.last_name || "",
                    phone_number: data?.phone_number || "",
                    email: data?.email || "",
                    instagram: data?.instagram || "",
                    telegram: data?.telegram || ""
                }}
                validationSchema={Yup.object({
                    first_name: Yup.string().required("Ім’я - обов'язкове поле"),
                    email: Yup.string().email("Неправильний формат пошти").required("Електронна пошта - обов'язкове поле")
                })}
                enableReinitialize
                onSubmit={(values, actions) => {}}
            >
                {props => (
                    <Form className="flex flex-col gap-[20px]">
                        <div className="flex items-start gap-[16px]">
                            <Input
                                label={"Ім’я"}
                                type="text"
                                onChange={(newValue) => {
                                    props.setFieldValue("first_name", newValue.trim());
                                }}
                                onBlur={props.handleBlur}
                                value={props.values.first_name}
                                name="first_name"
                                customStyle={{
                                    width: "!max-w-full !w-full"
                                }}
                                error={props.touched.first_name ? props.errors.first_name : ""}
                            />
                            <Input
                                label={"Прізвище"}
                                type="text"
                                onChange={(newValue) => {
                                    props.setFieldValue("last_name", newValue.trim())
                                }}
                                onBlur={props.handleBlur}
                                value={props.values.last_name}
                                name="last_name"
                                customStyle={{
                                    width: "!max-w-full !w-full"
                                }}
                                error={props.touched.last_name ? props.errors.last_name : ""}
                            />
                        </div>
                        <Input
                            label={"Телефон"}
                            type="tel"
                            onChange={(newValue) => {
                                props.setFieldValue("phone_number", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={props.values.phone_number}
                            name="phone_number"
                            customStyle={{
                                width: "!max-w-full !w-full"
                            }}
                            error={props.touched.phone_number ? props.errors.phone_number : ""}
                        />
                        <Input
                            label={"Електронна пошта"}
                            type="text"
                            onChange={(newValue) => {
                                props.setFieldValue("email", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={props.values.email}
                            name="email"
                            customStyle={{
                                width: "!max-w-full !w-full"
                            }}
                            error={props.touched.email ? props.errors.email : ""}
                        />
                        <Input
                            label={"Instagram"}
                            type="text"
                            onChange={(newValue) => {
                                props.setFieldValue("instagram", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={props.values.instagram}
                            name="instagram"
                            customStyle={{
                                width: "!max-w-full !w-full"
                            }}
                            error={props.touched.instagram ? props.errors.instagram : ""}
                        />
                        <Input
                            label={"Telegram"}
                            type="text"
                            onChange={(newValue) => {
                                props.setFieldValue("telegram", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={props.values.telegram}
                            name="telegram"
                            customStyle={{
                                width: "!max-w-full !w-full"
                            }}
                            error={props.touched.telegram ? props.errors.telegram : ""}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    )
})

export { UserInfoForm }